import { createApi } from "@/api/ApiFactory";
import { config } from "@/config/config";

const CarboneApi = createApi(config.CARBONE_API_URL);

export default CarboneApi;
